import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { db } from "./Firebase";
import {
  collection,
  getDocs,
  where,
  updateDoc,
  doc,
  query,
  orderBy,
  addDoc,
  deleteDoc,
  deleteField,
} from "firebase/firestore";
import * as XLSX from "xlsx";
import { MdDeleteForever } from "react-icons/md";
import { FormGroup } from "./CostCalculadora";

const Container = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: 10px auto 60px;
`;

const ContenedorBusqueda = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

// Estilos para la tabla
const ContenedorTabla = styled.div`
  width: 100%; /* Contenedor que se adapta al ancho completo */
  overflow-x: auto; /* Habilita el desplazamiento horizontal para pantallas pequeñas */
`;

const Tabla = styled.table`
  width: 100%; /* La tabla ocupa todo el ancho disponible */
  min-width: 900px; /* Establece un ancho mínimo para que se desplace en pantallas pequeñas */
  border-collapse: collapse;
  margin-top: 5px;
  color: black;
  th,
  td {
    border: 1.5px solid #ddd;
    padding: 5px;
    text-align: left;
    max-width: 130px;
    white-space: nowrap; /* Evitar que se dividan en múltiples líneas */
    overflow: hidden;
    text-overflow: ellipsis; /* Texto truncado con ... si sobrepasa */
    max-height: 1.5em; /* Altura fija para una línea */
    line-height: 1.5em;
    height: 1.5em;
  }
  th {
    background-color: #f2f2f2;
  }
`;

const Button = styled.button`
  padding: 5px 10px;
  border: none;
  background-color: #c20000; /* Rojo */
  color: white;
  cursor: pointer;
  &:hover {
    background-color: #6c757d; /* Gris en hover */
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
`;

const Modal = styled.div`
  position: fixed;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  padding: 25px;
  width: 600px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px #00000030;
`;

const ContenedorForm = styled.div`
  max-width: 450px;
  margin: auto;
`;

const Select = styled.select`
  width: 250px;
  max-width: 100%;
  margin-bottom: 10px;
  padding: 6px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  option {
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    direction: ltr;
  }
`;

const LiquidacionContratos = () => {
  const [contratos, setContratos] = useState([]);
  const [contratoSeleccionado, setContratoSeleccionado] = useState(null);
  const [mesFiltro, setMesFiltro] = useState("");
  const [pagina, setPagina] = useState(1);
  const [mostrarModalBorrar, setMostrarModalBorrar] = useState(false);
  const [contratoABorrar, setContratoABorrar] = useState(null);
  const [contratosDisponibles, setContratosDisponibles] = useState([]);
  const [formData, setFormData] = useState(null);
  const [busquedaContrato, setBusquedaContrato] = useState("");
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    cargarContratosDisponibles();
    cargarContratosVentas();
  }, []);

  const resultadosBusqueda = contratosDisponibles
    .filter((c) => !c.mesLiquidacion)
    .filter((c) => {
      const q = busquedaContrato.toLowerCase();
      return (
        c.nombreApellido?.toLowerCase().includes(q) ||
        c.empresaFactura?.toLowerCase().includes(q) ||
        c.contratoNumero?.toLowerCase().includes(q) ||
        c.tarifaTotal?.toString().includes(q)
      );
    });

  const cargarContratosDisponibles = async () => {
    const q = query(collection(db, "contratos"), orderBy("fecha", "desc"));
    const snap = await getDocs(q);
    const docs = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setContratosDisponibles(docs);
  };

  const cargarContratosVentas = async () => {
    const q = query(collection(db, "ventas"), orderBy("fecha", "desc"));
    const snap = await getDocs(q);
    const docs = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setContratos(docs);
  };

  const contratosConMes = contratos
    .filter((c) => c.mesLiquidacion)
    .sort((a, b) =>
      (b.mesLiquidacion || "").localeCompare(a.mesLiquidacion || "")
    );

  const contratosFiltrados = mesFiltro
    ? contratosConMes.filter((c) => c.mesLiquidacion === mesFiltro)
    : contratosConMes;

  const maxFilas = 7;
  const totalPaginas = Math.ceil(contratosFiltrados.length / maxFilas);
  const inicio = (pagina - 1) * maxFilas;
  const contratosPaginados = contratosFiltrados.slice(
    inicio,
    inicio + maxFilas
  );

  const objetoVacio = {
    empresaFactura: "",
    nombreApellido: "",
    fechaSalida: "",
    fechaRegreso: "",
    origen: "",
    destino: "",
    tipoDeServicio: "",
    kmCotizados: "",
    tarifaTotal: "",
    pasajeros: "",
    cantidadDeBuses: "",
    contratoNumero: "",
    mesLiquidacion: "",
  };

  const handleSeleccionar = (id) => {
    if (id === "nuevo") {
      setMostrarFormulario((prev) => !prev); // toggle
      const nuevo = { ...objetoVacio };
      setContratoSeleccionado(nuevo);
      setFormData(nuevo);
    } else {
      setMostrarFormulario(true); // asegúrate de mostrarlo al editar
      const encontrado =
        contratosDisponibles.find((c) => c.id === id) ||
        contratos.find((c) => c.id === id);
      setContratoSeleccionado(encontrado);
      setFormData({ ...encontrado }); // copia plana
    }
  };

  const validarFormulario = () => {
    const camposRequeridos = [
      "empresaFactura",
      "nombreApellido",
      "fechaSalida",
      "fechaRegreso",
      "origen",
      "destino",
      "tipoDeServicio",
      "kmCotizados",
      "tarifaTotal",
      "pasajeros",
      "cantidadDeBuses",
      "contratoNumero",
      "mesLiquidacion",
    ];
    const camposFaltantes = [];

    if (esNuevoContrato) {
      camposRequeridos.forEach((campo) => {
        if (!formData?.[campo]) {
          camposFaltantes.push(campo);
        }
      });
    } else {
      // En contratos existentes solo validar mesLiquidacion (o cualquier otro que esté habilitado)
      if (!formData?.mesLiquidacion) {
        camposFaltantes.push("cantidadDeBuses");
        camposFaltantes.push("pasajeros");
        camposFaltantes.push("tarifaTotal");
        camposFaltantes.push("kmCotizados");
        camposFaltantes.push("tipoDeServicio");
        camposFaltantes.push("mesLiquidacion");
      }
    }

    if (camposFaltantes.length > 0) {
      alert(
        `Faltan completar los siguientes campos:\n- ${camposFaltantes.join(
          "\n- "
        )}`
      );
      return false;
    }

    return true;
  };

  const handleGuardar = async () => {
    if (!validarFormulario()) return;
    setGuardando(true); // ⬅️ deshabilita botón

    let pesoKM;
    if (!parseFloat(formData.kmCotizados)) {
      pesoKM = 0;
    } else {
      pesoKM =
        parseFloat(formData.tarifaTotal || 0) /
        parseFloat(formData.kmCotizados);
    }

    const { id, ...ventaSinId } = formData;
    const ventaData = {
      ...ventaSinId,
      pesoKilometro: pesoKM,
      fecha: new Date().toISOString(),
    };

    if (!contratoSeleccionado?.id) {
      await addDoc(collection(db, "ventas"), ventaData);
    } else {
      await addDoc(collection(db, "ventas"), ventaData);
      await updateDoc(doc(db, "contratos", contratoSeleccionado.id), {
        mesLiquidacion: formData.mesLiquidacion,
      });
    }

    setContratoSeleccionado(null);
    setFormData(null);
    setMostrarFormulario(false);
    await cargarContratosDisponibles();
    await cargarContratosVentas();
    setGuardando(false); // ⬅️ vuelve a habilitar botón
  };

  const exportarExcel = () => {
    const rows = contratosFiltrados.map((c) => ({
      Empresa: c.empresaFactura,
      Cliente: c.nombreApellido,
      Salida: new Date(c.fechaSalida).toLocaleDateString("es-AR"),
      Origen: c.origen,
      Destino: c.destino,
      Tipo: c.tipoDeServicio,
      Tarifa: Number(c.tarifaTotal || 0),
      Km: Number(c.kmCotizados || 0),
      PesoPorKm: Number(c.pesoKilometro || 0),
      Pasajeros: Number(c.pasajeros || 0),
      Buses: Number(c.cantidadDeBuses || 0),
      Contrato: c.contratoNumero,
      Mes: c.mesLiquidacion,
    }));

    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Liquidaciones");
    XLSX.writeFile(wb, `liquidaciones_${mesFiltro || "todos"}.xlsx`);
  };

  const formatMesLetras = (mes) => {
    const [year, month] = mes.split("-");
    const date = new Date(`${year}-${month}-01T00:00:00`);
    return date.toLocaleDateString("es-AR", { year: "numeric", month: "long" });
  };

  const esNuevoContrato = contratoSeleccionado && !contratoSeleccionado.id;

  const calcularTotales = () => {
    let totalTarifa = 0;
    let totalKm = 0;
    let totalPasajeros = 0;
    let totalBuses = 0;
    let sumaPesos = 0;
    let cantidadPesos = 0;

    contratosFiltrados.forEach((c) => {
      const tarifa = parseFloat(c.tarifaTotal);
      const km = parseFloat(c.kmCotizados);
      const pasajeros = parseInt(c.pasajeros);
      const buses = parseInt(c.cantidadDeBuses);
      const peso = parseFloat(c.pesoKilometro);

      if (!isNaN(tarifa)) totalTarifa += tarifa;
      if (!isNaN(km)) totalKm += km;
      if (!isNaN(pasajeros)) totalPasajeros += pasajeros;
      if (!isNaN(buses)) totalBuses += buses;

      if (!isNaN(peso) && peso > 0) {
        sumaPesos += peso;
        cantidadPesos++;
      }
    });

    const promedioPeso = cantidadPesos > 0 ? sumaPesos / cantidadPesos : 0;

    return {
      totalTarifa,
      totalKm,
      totalPasajeros,
      totalBuses,
      promedioPeso,
      cantidadServicios: contratosFiltrados.length,
    };
  };

  const {
    totalTarifa,
    totalKm,
    totalPasajeros,
    totalBuses,
    promedioPeso,
    cantidadServicios,
  } = calcularTotales();

  return (
    <Container>
      <h4>Liquidación de Contratos</h4>
      <ContenedorBusqueda>
        <label>Buscar contrato:</label>
        <input
          type="text"
          placeholder="Empresa, fecha..."
          value={busquedaContrato}
          onChange={(e) => setBusquedaContrato(e.target.value)}
        />
        {busquedaContrato && resultadosBusqueda.length > 0 && (
          <ul
            style={{
              position: "absolute",
              width: "100%",
              top: "100%",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 10,
              maxHeight: 200,
              overflowY: "auto",
              backgroundColor: "white",
              border: "1px solid #ccc",
              borderRadius: "4px",
              boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
            }}
          >
            {resultadosBusqueda.map((c) => (
              <li
                key={c.id}
                onClick={() => {
                  handleSeleccionar(c.id);
                  setBusquedaContrato(""); // limpiar input
                }}
                style={{ padding: 8, cursor: "pointer" }}
              >
                {c.nombreApellido} -{" "}
                {new Date(
                  new Date(c.fechaSalida).toLocaleString("en-US", {
                    timeZone: "UTC",
                  })
                ).toLocaleDateString("es-ES")}{" "}
                -{" "}
                {Number(c.tarifaTotal || 0).toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                  maximumFractionDigits: 0,
                })}
              </li>
            ))}
          </ul>
        )}
        <Button
          style={{
            padding: "2px 5px",
          }}
          onClick={() => handleSeleccionar("nuevo")}
        >
          {mostrarFormulario ? "Borrar formulario" : "+ Ingreso Manual"}
        </Button>
      </ContenedorBusqueda>

      {mostrarFormulario && (
        <ContenedorForm>
          <FormGroup>
            <label>N° de contrato o N° de factura</label>
            <input
              value={formData?.contratoNumero || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  contratoNumero: e.target.value,
                }))
              }
              disabled={!esNuevoContrato}
            />
          </FormGroup>
          <FormGroup>
            <label>Empresa prestadora:</label>
            <input
              value={formData?.empresaFactura || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  empresaFactura: e.target.value,
                }))
              }
              disabled={!esNuevoContrato}
            />
          </FormGroup>
          <FormGroup>
            <label>Cliente:</label>
            <input
              value={formData?.nombreApellido || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  nombreApellido: e.target.value,
                }))
              }
              disabled={!esNuevoContrato}
            />
          </FormGroup>
          <FormGroup>
            <label>Salida:</label>
            <input
              type="date"
              value={
                formData?.fechaSalida
                  ? new Date(formData.fechaSalida).toISOString().split("T")[0]
                  : ""
              }
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  fechaSalida: e.target.value,
                }))
              }
              disabled={!esNuevoContrato}
            />
          </FormGroup>

          <FormGroup>
            <label>Regreso:</label>
            <input
              type="date"
              value={
                formData?.fechaRegreso
                  ? new Date(formData.fechaRegreso).toISOString().split("T")[0]
                  : ""
              }
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  fechaRegreso: e.target.value,
                }))
              }
              disabled={!esNuevoContrato}
            />
          </FormGroup>

          <FormGroup>
            <label>Origen:</label>
            <input
              value={formData?.origen || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  origen: e.target.value,
                }))
              }
              disabled={!esNuevoContrato}
            />
          </FormGroup>
          <FormGroup>
            <label>Destino:</label>
            <input
              value={formData?.destino || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  destino: e.target.value,
                }))
              }
              disabled={!esNuevoContrato}
            />
          </FormGroup>
          <FormGroup>
            <label>Tipo de Servicio:</label>
            <Select
              value={formData?.tipoDeServicio || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  tipoDeServicio: e.target.value,
                }))
              }
            >
              <option value="">Seleccione</option>
              <option value="Nacional">Nacional</option>
              <option value="Internacional">Internacional</option>
              <option value="Provincial">Provincial</option>
            </Select>
          </FormGroup>

          <FormGroup>
            <label>km Cotizados:</label>
            <input
              value={formData?.kmCotizados || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  kmCotizados: e.target.value,
                }))
              }
              placeholder="Km Cotizados"
              type="number"
            />
          </FormGroup>
          <FormGroup>
            <label>Tarifa:</label>
            <input
              value={formData?.tarifaTotal || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  tarifaTotal: e.target.value,
                }))
              }
              type="number"
            />
          </FormGroup>
          <FormGroup>
            <label>Cantidad de pax:</label>
            <input
              value={formData?.pasajeros || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  pasajeros: e.target.value,
                }))
              }
              placeholder="Pasajeros"
              type="number"
            />
          </FormGroup>
          <FormGroup>
            <label>Cantidad de unidades:</label>
            <input
              value={formData?.cantidadDeBuses || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  cantidadDeBuses: e.target.value,
                }))
              }
              placeholder="Cantidad de Buses"
              type="number"
            />
          </FormGroup>
          <FormGroup>
            <label>Mes Liquidación:</label>
            <input
              type="month"
              value={formData?.mesLiquidacion || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  mesLiquidacion: e.target.value,
                }))
              }
              required
            />
          </FormGroup>
          <div
            style={{ width: "100%", textAlign: "center", padding: "10px 0px" }}
          >
            <Button
              style={{ width: "450px" }}
              onClick={handleGuardar}
              disabled={guardando}
            >
              {guardando ? "Guardando..." : "Confirmar"}
            </Button>
          </div>
        </ContenedorForm>
      )}

      <div style={{ marginTop: "2rem" }}>
        <h4>Contratos Liquidados</h4>
        <Select
          onChange={(e) => setMesFiltro(e.target.value)}
          value={mesFiltro}
          style={{ marginRight: "2rem" }}
        >
          <option value="">Todos los meses</option>
          {[...new Set(contratosConMes.map((c) => c.mesLiquidacion))]
            .filter(Boolean)
            .sort((a, b) => b.localeCompare(a)) // más reciente primero
            .map((mes) => (
              <option key={mes} value={mes}>
                {formatMesLetras(mes)}
              </option>
            ))}
        </Select>
        <Button onClick={exportarExcel}>Descargar Excel</Button>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginTop: "5px",
            flexWrap: "wrap", // por si se alarga mucho en pantallas chicas
          }}
        >
          <span style={{ fontWeight: "bold" }}>
            Venta:{" "}
            {totalTarifa.toLocaleString("es-AR", {
              style: "currency",
              currency: "ARS",
              maximumFractionDigits: 0,
            })}
          </span>

          <span style={{ fontWeight: "bold" }}>
            Servicios: {cantidadServicios}
          </span>

          <span style={{ fontWeight: "bold" }}>
            Km vendidos: {totalKm.toLocaleString("es-AR")}
          </span>

          <span style={{ fontWeight: "bold" }}>
            Pax Transportados: {totalPasajeros.toLocaleString("es-AR")}
          </span>

          <span style={{ fontWeight: "bold" }}>
            Buses: {totalBuses.toLocaleString("es-AR")}
          </span>

          <span style={{ fontWeight: "bold" }}>
            Promedio $/KM:{" "}
            {promedioPeso.toLocaleString("es-AR", {
              style: "currency",
              currency: "ARS",
              maximumFractionDigits: 0,
            })}
          </span>
        </div>

        <ContenedorTabla>
          <Tabla>
            <thead>
              <tr>
                <th>Empresa</th>
                <th style={{ maxWidth: "160px" }}>Cliente</th>
                <th>Salida</th>
                <th>Origen</th>
                <th>Destino</th>
                <th>Tipo</th>
                <th>Tarifa</th>
                <th>Km</th>
                <th>$ x Km</th>
                <th>Pasajeros</th>
                <th>Buses</th>
                <th>Contrato / Factura</th>
                <th>Eliminar</th>
              </tr>
            </thead>
            <tbody>
              {contratosPaginados.map((c) => (
                <tr key={c.id}>
                  <td>{c.empresaFactura}</td>
                  <td style={{ textAlign: "left", maxWidth: "160px" }}>
                    {c.nombreApellido}
                  </td>
                  <td>
                    {new Date(
                      new Date(c.fechaSalida).toLocaleString("en-US", {
                        timeZone: "UTC",
                      })
                    ).toLocaleDateString("es-ES")}
                  </td>
                  <td>{c.origen}</td>
                  <td>{c.destino}</td>
                  <td>{c.tipoDeServicio}</td>
                  <td style={{ textAlign: "right", fontFamily: "monospace" }}>
                    {Number(c.tarifaTotal || 0).toLocaleString("es-AR", {
                      style: "currency",
                      currency: "ARS",
                      maximumFractionDigits: 0,
                    })}
                  </td>
                  <td style={{ textAlign: "center" }}>{c.kmCotizados}</td>
                  <td style={{ textAlign: "right", fontFamily: "monospace" }}>
                    {Number(c.pesoKilometro || 0) === 0
                      ? "-"
                      : Number(c.pesoKilometro).toLocaleString("es-AR", {
                          style: "currency",
                          currency: "ARS",
                          maximumFractionDigits: 0,
                        })}
                  </td>
                  <td style={{ textAlign: "center" }}>{c.pasajeros || "-"}</td>
                  <td style={{ textAlign: "center" }}>
                    {c.cantidadDeBuses || "-"}
                  </td>
                  <td>{c.contratoNumero}</td>
                  <td>
                    <MdDeleteForever
                      size={20}
                      style={{ cursor: "pointer", color: "red" }}
                      onClick={() => {
                        setContratoABorrar(c);
                        setMostrarModalBorrar(true);
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Tabla>
        </ContenedorTabla>

        <div style={{ marginTop: "1rem" }}>
          <Button onClick={() => setPagina((p) => Math.max(p - 1, 1))}>
            Anterior
          </Button>
          <span style={{ margin: "0 10px" }}>
            Página {pagina} de {totalPaginas}
          </span>
          <Button
            onClick={() => setPagina((p) => Math.min(p + 1, totalPaginas))}
          >
            Siguiente
          </Button>
        </div>
      </div>

      {mostrarModalBorrar && (
        <ModalOverlay>
          <Modal>
            <h4>¿Eliminar este contrato?</h4>
            <p>Contrato N°: {contratoABorrar?.contratoNumero}</p>
            <div
              style={{ display: "flex", gap: "1rem", justifyContent: "center" }}
            >
              <Button
                onClick={async () => {
                  setGuardando(true); // ⬅️ deshabilita botón
                  const contratoNumero = contratoABorrar.contratoNumero;

                  // 1. Borrar el documento en 'ventas'
                  await deleteDoc(doc(db, "ventas", contratoABorrar.id));

                  // 2. Buscar en 'contratos' por contratoNumero
                  const contratosQuery = query(
                    collection(db, "contratos"),
                    where("contratoNumero", "==", contratoNumero)
                  );
                  const querySnapshot = await getDocs(contratosQuery);

                  // 3. Borrar solo el campo mesLiquidacion si hay resultados
                  for (const docSnap of querySnapshot.docs) {
                    await updateDoc(docSnap.ref, {
                      mesLiquidacion: deleteField(),
                    });
                  }

                  // 4. Refrescar UI
                  await cargarContratosVentas();
                  await cargarContratosDisponibles();
                  setMostrarModalBorrar(false);
                  setContratoABorrar(null);
                  setGuardando(false); // ⬅️ vuelve a habilitar botón
                }}
                disabled={guardando}
              >
                {guardando ? "Eliminando..." : "Confirmar"}
              </Button>
              <Button onClick={() => setMostrarModalBorrar(false)}>
                Cancelar
              </Button>
            </div>
          </Modal>
        </ModalOverlay>
      )}
    </Container>
  );
};

export default LiquidacionContratos;
